module.exports = __webpack_public_path__ + "images/tencent_docs/doc-34b55e7c3c1dbd26d8a77c57b11fdf99.svg";